<template>
  <div class="col-md-12">
    <textarea
      v-model="value"
      :id="getFieldID(schema)"
      :class="`${schema.fieldClasses} form-control`"
      :disabled="disabled"
      :maxlength="schema.max"
      :minlength="schema.min"
      :placeholder="schema.placeholder"
      :readonly="schema.readonly"
      :required="schema.required"
      :rows="schema.rows || 2"
      :name="schema.inputName"
    ></textarea>
    <div
      v-if="schema.max"
      class="text-right col-md-12 text-small text-gray mt-1 pr-0"
      style="color: #444;"
    >
      {{ value ? value.length : 0 }}/{{ schema.max }}
    </div>
  </div>
</template>

<script>
import { abstractField } from 'vue-form-generator';

export default {
  mixins: [abstractField],
};
</script>



// WEBPACK FOOTER //
// src/components/custom_fields/general/fieldFancyTextArea.vue